/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  LedgerWithdrawRequestSelfOptions,
  LedgerWithdrawRequestSelfResponses,
} from '../types/LedgerWithdrawRequestSelf'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Withdraw assets from the logged in user's account to the outside world. Note that this does not interact with any external systems; it simply deducts the amount from the user's available balance in the ledger. Actual transfer of assets must be handled separately.
 * @summary Initiate a withdrawal request for the logged in user to the outside world
 * {@link /v1/ledger/withdraw/requests/self}
 */
export function ledgerWithdrawRequestSelf<ThrowOnError extends boolean = true>(
  options: Options<LedgerWithdrawRequestSelfOptions, ThrowOnError>,
): Unwrappable<RequestResult<LedgerWithdrawRequestSelfResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/ledger/withdraw/requests/self',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<LedgerWithdrawRequestSelfResponses, ThrowOnError>>,
  )
}
